import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';
import { AppSettingsState } from 'app/store/appSettings/AppSettingsState';
import {
    defaultFillsGraphConfiguration,
    FillsChartType,
    FillsGraphConfiguration,
} from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';
import FillsGraphByOrderIdOrSymQtyStreamRequest from 'communication/types/fillsGraph/FillsGraphByOrderIdOrSymQtyStreamRequest';
import State from 'store/State';
import { buildFillsGraphRequest } from 'widgets/fillsGraph/store/data/FillsGraphStreamRequest';
import { selectPlCapsuleConfig } from 'widgets/plCapsule/store/config/configslice';

export function createFillsGraphRequestForPlCapsule(
    orderIds: string[],
    portfolioSelection: PortfolioSelectionWrapper,
    widgetKey: string,
    appSettings: AppSettingsState,
    state: State
): FillsGraphByOrderIdOrSymQtyStreamRequest | undefined {
    const config = selectPlCapsuleConfig(state, widgetKey);

    const fillsGraphConfig: FillsGraphConfiguration = {
        ...defaultFillsGraphConfiguration,
    };
    fillsGraphConfig[FillsChartType.PnL].pnlChartBenchmark =
        config.pnlChartBenchmark;

    return buildFillsGraphRequest(
        orderIds,
        portfolioSelection,
        appSettings.symbology,
        fillsGraphConfig
    );
}
